import { OnboardingDocument, OnboardingStatus } from '../interfaces/Onboarding';
import { useGetQuery } from './useGetQuery';


export const useOnboardingDocuments = ({corporateId, status}:{corporateId: string; status: number}) => {
    const {
        isLoading,
        entries: onboardingDocuments,
        refetch
    } = useGetQuery< OnboardingDocument[] >({
        url: `/corporate/${corporateId}/onboarding/documents`,
        cacheKey: 'onboarding-documents',
        enabled: Boolean(corporateId) && (status === OnboardingStatus.UPLOAD_DOCUMENT || status === OnboardingStatus.DOCUMENTS_REVIEW || status === OnboardingStatus.DOCUMENTS_REJECTED)
    });

    return { isLoading, onboardingDocuments, refetch };
};
